import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';


const RangePricetag = observer(({ configStore, voucherStore }) => {
  const [showMessage, setShowMessage] = useState(false);
  const [showRangeMessage,setShowRangeMessage] = useState(false);
  var { t } = useTranslation();


  const handleAmountChange = (e) => {
    const amount = e.target.value;
    configStore.setPrice(amount);
  //  setShowMessage(amount == 0);
  };

  const handleInputBlur = () => {
    const amount = configStore.price;
    setShowMessage(amount == 0);
    if(amount > 0){
    setShowRangeMessage(parseFloat(amount) < parseFloat(voucherStore.voucher.price_configuration.from) || parseFloat(amount) > parseFloat(voucherStore.voucher.price_configuration.to)) 
  }
  };

  return (
    <div style={{ maxWidth: '400px' }}>
      <input
        type="number"
        name="gurado_amount"
        id="gurado_amount"
        style={{height:'50px'}}
        className="gurado-storefront-form-control"
        min={voucherStore.voucher.price_configuration.from}
        max={voucherStore.voucher.price_configuration.to}
        onChange={handleAmountChange}
        onBlur={handleInputBlur}
        placeholder={`${t('AMOUNT')} (${t('FROM')} ${parseFloat(voucherStore.voucher.price_configuration.from).toFixed(2).replace('.', ',')} - ${parseFloat(voucherStore.voucher.price_configuration.to).toFixed(2).replace('.', ',')} ${voucherStore.voucher.currency_code})`}

      />
      {showMessage && <p style={{color:'red'}}>Bitte geben Sie einen Betrag ein.</p>}  
      {showRangeMessage && <p style ={{color:'red'}}> Der Betrag muss im Bereich von {voucherStore.voucher.price_configuration.from} - {voucherStore.voucher.price_configuration.to} {voucherStore.voucher.currency_code} liegen </p>} 
    </div>
  );
});

export default RangePricetag;